module.exports = __webpack_public_path__ + "img/375.143b7128.jpg";